<template>
  <div>
    <header-top></header-top>
    <div class="search">
      <div class="searchTop">
        <div class="topNav clearfix">
          <ul class="nav clearfix">
            <li @click="changeType(1)">
              <span :class="{ active: type == 1 }">
                {{ $t("search.视频") }}
                <i v-if="type == 1" class="line"></i>
              </span>
              <i>{{ videoCount == "999" ? videoCount + "+" : videoCount }}</i>
            </li>
            <li @click="changeType(2)">
              <span :class="{ active: type == 2 }">
                {{ $t("search.用户") }}
                <i v-if="type == 2" class="line"></i>
              </span>
              <i>{{ userCount == "999" ? userCount + "+" : userCount }}</i>
            </li>
            <li @click="changeType(5)">
              <span :class="{ active: type == 5 }">
                {{ $t("search.文章") }}
                <i v-if="type == 5" class="line"></i>
              </span>
              <i>{{
                articleCount == "999" ? articleCount + "+" : articleCount
              }}</i>
            </li>
            <li @click="changeType(3)">
              <span :class="{ active: type == 3 }">
                {{ $t("search.频道") }}
                <i v-if="type == 3" class="line"></i>
              </span>
              <i>{{ topicCount == "999" ? topicCount + "+" : topicCount }}</i>
            </li>
            <li @click="changeType(4)">
              <span :class="{ active: type == 4 }">
                {{ $t("search.活动") }}
                <i v-if="type == 4" class="line"></i>
              </span>
              <i>{{
                activityCount == "999" ? activityCount + "+" : activityCount
              }}</i>
            </li>
            <li @click="changeType(6)">
              <span :class="{ active: type == 6 }">
                {{$t('collect.招聘职位')}}
                <i v-if="type == 6" class="line"></i>
              </span>
              <i>{{
                recruitCount == "999" ? recruitCount + "+" : recruitCount
              }}</i>
            </li>
          </ul>
          <!-- <div class="searchInput">
            <input type="text" v-model="content" @keyup.enter="searchSubmit" />
            <img
              @click="searchSubmit"
              src="/static/v2/header/head_search_icon@2x.png"
              alt
            />
          </div> -->
        </div>
        <div class="tagsBox" v-if="type == 1 && tagsData.length">
          <div
            class="tags"
            :class="{ hideTags: openTages }"
            :style="openTages ? { height: rightScrollHeight + 'px' } : {}"
          >
            <div class="group clearfix">
              <div class="name">{{ $t("global.分类") }}</div>
              <div class="clearfix" ref="classTagHeight">
                <ul class="groupTag clearfix">
                  <li
                    class="groupTagLi"
                    :class="{ active: y == classIndex }"
                    @click="classSubTags(tag, 1, y)"
                    v-for="(tag, y) in classTags.tagEditFroms"
                    :key="y"
                  >
                    {{ language === "zh" ? tag.name : tag.enName }}
                  </li>
                </ul>
                <ul
                  class="subTag clearfix"
                  v-if="classSubTag.data && classSubTag.data.length"
                >
                  <li
                    class="subTagLi"
                    v-for="(tag, y) in classSubTag.data"
                    :class="{ active: y == classSubIndex }"
                    @click="selectTags(classSubTag.id, tag, 1, y)"
                    :key="y"
                  >
                    {{ language === "zh" ? tag.name : tag.enName }}
                  </li>
                </ul>
              </div>
              <!-- <div v-if="classMore" class="open">
                <span v-if="classTogger" @click="classOpen(1)">
                  更多
                  <img src="/static/newSearch/icon_more_arrow_grey_hover@2x.png" alt />
                </span>
                <span v-else @click="classOpen(2)">
                  收起
                  <img src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png" alt />
                </span>
              </div>-->
            </div>
            <div class="group clearfix" :class="{ hideBottom: openTages }">
              <div class="name">{{ $t("global.行业") }}</div>
              <div class="clearfix" ref="industryTagHeight">
                <ul
                  class="groupTag"
                  ref="industryTagHeight1"
                  :class="industryMore && industryTogger ? 'hideMore' : ''"
                >
                  <li
                    class="groupTagLi"
                    :class="{ active: y == industryIndex }"
                    @click="classSubTags(tag, 2, y)"
                    v-for="(tag, y) in industryTags.tagEditFroms"
                    :key="y"
                  >
                    {{ language === "zh" ? tag.name : tag.enName }}
                  </li>
                </ul>
                <ul
                  class="subTag clearfix"
                  v-if="industrySubTag.data && industrySubTag.data.length"
                >
                  <li
                    class="subTagLi"
                    :class="{ active: y == industrySubIndex }"
                    v-for="(tag, y) in industrySubTag.data"
                    @click="selectTags(industrySubTag.id, tag, 2, y)"
                    :key="y"
                  >
                    {{ language === "zh" ? tag.name : tag.enName }}
                  </li>
                </ul>
              </div>
              <div v-if="industryMore" class="open">
                <span v-if="industryTogger" @click="classOpen(3)">
                  {{ $t("global.更多")
                  }}<img
                    src="/static/newSearch/icon_more_arrow_grey_hover@2x.png"
                    alt
                  />
                </span>
                <span v-else @click="classOpen(4)">
                  {{ $t("global.收起")
                  }}<img
                    src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png"
                    alt
                  />
                </span>
              </div>
            </div>
            <div class="group clearfix">
              <div class="name">{{$t('video.应用场景')}}</div>
              <ul
                class="groupTag"
                ref="applicationTagHeight"
                :class="applicationMore&&applicationTogger?'hideMore':''"
              >
                <li
                  class="groupTagLi"
                  :class="{'active':y==applicationIndex}"
                  @click="classSubTags(tag, 3, y)"
                  v-for="(tag,y) in applicationTags.tagEditFroms"
                  :key="y"
                >{{language === 'zh'?tag.name:tag.enName}}</li>
              </ul>
              <ul
                class="subTag clearfix"
                v-if="applicationSubTag.data&&applicationSubTag.data.length"
              >
                <li
                  class="subTagLi"
                  :class="{'active':y==applicationSubIndex}"
                  v-for="(tag,y) in applicationSubTag.data"
                  @click="selectTags(applicationSubTag.id,tag,3,y)"
                  :key="y"
                >{{language === 'zh'?tag.name:tag.enName}}</li>
              </ul>
              <div v-if="applicationMore" class="open">
                <span v-if="applicationTogger" @click="applicationTogger=false">
                  {{$t('global.更多')
                  }}<img
                    src="/static/newSearch/icon_more_arrow_grey_hover@2x.png"
                    alt
                  />
                </span>
                <span v-else @click="applicationTogger=true">
                  {{$t('global.收起')
                  }}<img
                    src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png"
                    alt
                  />
                </span>
              </div>
            </div>
            <div class="group clearfix">
              <div class="name">{{ $t("global.热门标签") }}</div>
              <ul
                class="groupTag"
                ref="hotTagHeight"
                :class="hotMore && hotTogger ? 'hideMore' : ''"
              >
                <li
                  class="groupTagLi"
                  :class="{ active: y == hotIndex }"
                  @click="classSubTags(tag, 4, y)"
                  v-for="(tag, y) in hotTags.tagEditFroms"
                  :key="y"
                >
                  {{ language === "zh" ? tag.name : tag.enName }}
                </li>
              </ul>
              <ul
                class="subTag clearfix"
                v-if="hotSubTag.data && hotSubTag.data.length"
              >
                <li
                  class="subTagLi"
                  :class="{ active: y == hotSubIndex }"
                  v-for="(tag, y) in hotSubTag.data"
                  @click="selectTags(hotSubTag.id, tag, 4, y)"
                  :key="y"
                >
                  {{ language === "zh" ? tag.name : tag.enName }}
                </li>
              </ul>
              <div v-if="hotMore" class="open">
                <span v-if="hotTogger" @click="hotTogger = false">
                  {{ $t("global.更多")
                  }}<img
                    src="/static/newSearch/icon_more_arrow_grey_hover@2x.png"
                    alt
                  />
                </span>
                <span v-else @click="hotTogger = true">
                  {{ $t("global.收起")
                  }}<img
                    src="/static/newSearch/icon_more_arrow_grey_close_hover@2x.png"
                    alt
                  />
                </span>
              </div>
            </div>
          </div>
          <div
            class="openTages"
            @click="stopOpen"
            @mouseenter="isShow = true"
            @mouseleave="isShow = false"
          >
            <img
              v-if="isShow"
              :src="
                !openTages
                  ? '/static/newSearch/icon_more_arrow_grey_close_hover@2x.png'
                  : '/static/newSearch/icon_more_arrow_grey_hover@2x.png'
              "
              alt
            />
            <img
              v-else
              :src="
                !openTages
                  ? '/static/newSearch/icon_more_arrow_grey_close@2x.png'
                  : '/static/newSearch/icon_more_arrow_grey@2x.png'
              "
              alt
            />
          </div>
        </div>
      </div>
      <div class="searchVideo clearfix" v-if="type == 1">
        <div class="searchLeft">
          <div v-if="lists.length">
            <div class="searchResult clearfix">
              <span class="left">
                {{ $t("search.搜索") }}“<i>{{ options.keyword }}</i
                >”，{{ $t("search.共找到") }}
                <i>{{ videoCount == "999" ? videoCount + "+" : videoCount }}</i>
                {{ $t("search.个结果") }}
              </span>
              <a
                class="right"
                href="http://manabang.mikecrm.com/kl4FGOK"
                target="_blank"
              >
                {{ $t("search.对结果不满意？请告诉我们")
                }}<img src="/static/newSearch/go_arrow@2x.png" alt />
              </a>
            </div>
            <div class="sort clearfix">
              <span
                @click="videoOrderBy(null)"
                :class="{ active: options.videoOrderBy == null }"
                >{{ $t("search.综合排序") }}</span
              >
              <span
                @click="videoOrderBy(1)"
                :class="{ active: options.videoOrderBy == 1 }"
                >{{ $t("search.最新创作") }}</span
              >
              <span
                @click="videoOrderBy(2)"
                :class="{ active: options.videoOrderBy == 2 }"
                >{{ $t("search.最多浏览") }}</span
              >
              <span
                @click="videoOrderBy(3)"
                :class="{ active: options.videoOrderBy == 3 }"
                >{{ $t("search.最多点赞") }}</span
              >
            </div>
            <div class="list">
              <div class="list_li" v-for="(item, i) in lists" :key="i">
                <div
                  class="li_video clearfix"
                  @click.stop.prevent="goto('video', item.videoId)"
                  v-if="item.domainType == '0'"
                >
                  <div class="left">
                    <img
                      :src="item.thumb | imageUrl('', 400, 224, '', 'gif')"
                      alt
                    />
                    <span>{{ item.duration | secondToDate }}</span>
                  </div>
                  <div class="right">
                    <p class="title1" v-html="highlight(item.title)">
                      {{ item.title }}
                    </p>
                    <p
                      class="title2"
                      v-html="
                        highlight(subKeyArr(delStyleTag(item.introduction)))
                      "
                    ></p>
                    <p class="title3">
                      <span
                        class="name"
                        @click.stop.prevent="goto('people', item.userId)"
                        v-html="highlight(item.nickName)"
                      ></span>
                      <span class="time">{{ item.date }}</span>
                      <span class="countNumber"
                        ><img src="/static/video/view_icon@2x.png" alt />{{
                          item.viewCount
                        }}</span
                      >
                    </p>
                    <p class="title4">
                      <span
                        v-for="(tag, i) in item.tagGroupInfoList"
                        :key="i"
                        v-html="highlight(tag)"
                      ></span>
                    </p>
                    <!-- <p class="title5">
                      <img src="/static/video/view_icon@2x.png" alt />{{item.viewCount}}
                    </p> -->
                  </div>
                </div>
                <div
                  class="li_article clearfix"
                  v-if="item.domainType == '2'"
                  @click.stop.prevent="goto('article', item.articleId)"
                >
                  <div class="left">
                    <img
                      :src="item.image | imageUrl('', 200, 112, '', 'gif')"
                      alt
                      v-if="item.image !== ''"
                    />
                    <img
                      class="deflautImg"
                      v-else
                      src="/static/newSearch/article_img_empty@2x.png"
                      alt
                    />
                    <span>{{ $t("search.文章") }}</span>
                  </div>
                  <div class="right">
                    <p class="title1" v-html="highlight(item.title)"></p>
                    <p
                      class="title2"
                      v-html="
                        highlight(subKeyArr(delStyleTag(item.introduction)))
                      "
                    ></p>
                    <p class="title3">
                      <span
                        class="name"
                        v-html="highlight(item.articleNickName)"
                        @click.stop.prevent="goto('people', item.articleUserId)"
                      ></span>
                      <span class="time">{{ timeStamp(item.createTime) }}</span>
                    </p>
                  </div>
                </div>
                <div
                  class="li_channel clearfix"
                  v-if="item.domainType == '1'"
                  @click.stop.prevent="goto('subject', item.id)"
                >
                  <div class="left">
                    <img :src="item.topicThumb | imageUrl('', 200, 200)" alt />
                    <span>{{ $t("search.频道") }}</span>
                  </div>
                  <div class="right">
                    <p class="title1" v-html="highlight(item.title)"></p>
                    <p
                      class="title2"
                      v-html="
                        highlight(subKeyArr(delStyleTag(item.introduction)))
                      "
                    ></p>
                    <p class="title3">
                      <span>
                        {{ $t("search.视频") }}
                        <i>{{ item.videoCount || 0 }}</i>
                      </span>
                      <span>
                        {{ $t("search.活动") }}
                        <i>{{ item.activityCount || 0 }}</i>
                      </span>
                      <span>
                        {{ $t("search.成员") }}
                        <i>{{ item.memberCount || 0 }}</i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="searchResult clearfix" v-if="hasNextPage">
              <a
                class="right"
                href="http://manabang.mikecrm.com/kl4FGOK"
                target="_blank"
              >
                {{ $t("search.对结果不满意？请告诉我们")
                }}<img src="/static/newSearch/go_arrow@2x.png" alt />
              </a>
            </div>
          </div>
          <div v-if="isShowNone&&!lists.length" class="noDataImg">
            <div class="noDataBox">
              <img src="/static/newSearch/video_empty@2x.png" alt />
              <p>{{ $t("search.没有匹配的视频") }}</p>
            </div>
          </div>
        </div>
        <div class="searchRight">
          <div class="hot" v-if="hotList.length">
            <p class="hot_title">{{ $t("search.热门周榜") }}</p>
            <div
              class="topThree clearfix"
              v-for="(item, i) in hotList.slice(0, 3)"
              :key="i"
              @click.stop.prevent="goto('video', item.videoId)"
            >
              <p class="number">{{ i + 1 }}</p>
              <img
                class="topImg"
                :src="item.thumb | imageUrl('', 190, 108)"
                alt
              />
              <div class="information">
                <p class="title">{{ item.title }}</p>
                <p
                  class="name"
                  @click.stop.prevent="goto('people', item.userId)"
                >
                  {{ item.userNickName }}
                </p>
              </div>
            </div>
            <div
              class="topEnd clearfix"
              v-for="(item, y) in hotList.slice(3, 10)"
              :key="y + '0'"
              @click.stop.prevent="goto('video', item.videoId)"
            >
              <p class="number">{{ y + 4 }}</p>
              <p class="information">
                <span class="title">{{ item.title }}-</span>
                <span
                  class="name"
                  @click.stop.prevent="goto('people', item.userId)"
                  >{{ item.userNickName }}</span
                >
              </p>
            </div>
          </div>
          <div class="operation" v-if="locationList.length">
            <img
              class="locationImg"
              @click="gotoLocation"
              :src="
                JSON.parse(locationList[0].image)[0].key
                  | imageUrl('', 570, 320)
              "
              alt=""
            />
            <div class="advertisement" v-if="locationList[0].type == '2'">
              {{ $t("video.广告") }}
            </div>
          </div>
          <div class="uploadApp">
            <img
              :src="
                language === 'zh'
                  ? '/static/video/Sidebar_app_promo_CN@2x.png'
                  : '/static/video/Sidebar_app_promo_EN@2x.png'
              "
              alt
            />
          </div>
        </div>
      </div>
      <div class="searchVideoArticle" v-if="type == 5">
        <div v-if="lists.length">
          <div
            class="articleList clearfix"
            v-for="(item, i) in lists"
            :key="i"
            @click.stop.prevent="goto('article', item.id)"
          >
            <div class="left" :class="{ noImg: item.image == '' }">
              <p class="title1" v-html="highlight(item.title)"></p>
              <p
                class="title2"
                v-html="highlight(subKeyArr(delStyleTag(item.content)))"
              ></p>
              <div class="information clearfix">
                <div
                  class="name"
                  @click.stop.prevent="goto('people', item.userId)"
                >
                  <img
                    :src="
                      item.avatar
                        | imageUrl('/static/profile_img_default.png', 60, 60)
                    "
                    alt
                  />
                  <span v-html="highlight(item.nickName)"></span>
                </div>
                <p class="time">{{ timeStamp(item.createTime) }}</p>
                <!--<div class="amount">
                  <img src="/static/video/view_icon@2x.png" alt />
                  {{item.viewCount || 0}}
                </div>-->
              </div>
            </div>
            <div class="right" v-if="item.image">
              <img :src="item.image | imageUrl('', 346, 200, '', 'gif')" alt />
            </div>
          </div>
        </div>
        <div v-if="isShowNone&&!lists.length" class="noDataImg">
          <div class="noDataBox">
            <img src="/static/newSearch/article_empty@2x.png" alt />
            <p>{{ $t("search.没有匹配的文章") }}</p>
          </div>
        </div>
      </div>
      <div class="searchChannel" v-if="type == 3">
        <ul class="channelUl clearfix" v-if="lists.length">
          <li
            class="channelLi clearfix"
            v-for="(item, i) in lists"
            :key="i"
            @click.stop.prevent="goto('subject', item.id)"
          >
            <div class="left">
              <img :src="item.thumb | imageUrl('', 250, 250)" alt />
            </div>
            <div class="right">
              <p class="title1" v-html="highlight(item.title)"></p>
              <p
                class="title2"
                v-html="highlight(subKeyArr(delStyleTag(item.introduction)))"
              ></p>
              <p class="title3">
                <span>
                  {{$t('global.视频')}}
                  <i>{{ item.videoCount }}</i>
                </span>
                <span>
                  {{$t('global.活动')}}
                  <i>{{ item.activityCount }}</i>
                </span>
                <span>
                  {{$t('global.成员')}}
                  <i>{{ item.memberCount }}</i>
                </span>
              </p>
            </div>
          </li>
        </ul>
        <div v-if="isShowNone&&!lists.length" class="noDataImg">
          <div class="noDataBox">
            <img src="/static/newSearch/channel_empty@2x.png" alt />
            <p>{{ $t("search.没有匹配的频道") }}</p>
          </div>
        </div>
      </div>
      <div class="searchActivity" v-if="type == 4">
        <ul class="activityUl clearfix" v-if="lists.length">
          <li
            class="activityLi"
            v-for="(item, i) in lists"
            :key="i"
            @click.stop.prevent="goto('activity', item.id ,item)"
          >
            <div class="activityImg">
              <img :src="item.verticalThumb | imageUrl('', 510, 678)" alt />
              <p class="title1" v-if="item.type == 1">{{$t('live.直播')}}</p>
              <p
                class="title2 liveing"
                v-if="item.type == 1 && item.status == 5"
              >
                {{$t('live.直播中')}}
              </p>
              <p class="title2 begining" v-if="item.status == 2">{{$t('live.即将开始')}}</p>
              <p class="title2 Finished" v-if="item.status == 4">{{$t('global.已结束')}}</p>
              <p
                class="title2 liveing"
                v-if="item.type == 2 && item.status == 5"
              >
                {{$t('global.进行中')}}
              </p>
            </div>
            <p class="title3" v-html="highlight(item.title)"></p>
            <p class="title4">
              {{ item.holdStartTime | formatDate("YYYY.MM.DD") }} -
              {{ item.holdEndTime | formatDate("YYYY.MM.DD") }}
            </p>
          </li>
        </ul>
        <div v-if="isShowNone&&!lists.length" class="noDataImg">
          <div class="noDataBox">
            <img src="/static/newSearch/event_empty@2x.png" alt />
            <p>{{ $t("search.没有匹配的活动") }}</p>
          </div>
        </div>
      </div>
      <div class="searchUser" v-if="type == 2">
        <ul class="userUl" v-if="lists.length">
          <li class="userLi clearfix" v-for="(item, i) in lists" :key="i">
            <div
              class="avactImg"
              @click.stop.prevent="goto('people', item.userId)"
            >
              <img
                :src="
                  item.avatar
                    | imageUrl('/static/profile_img_default.png', 190, 190)
                "
                alt
              />
            </div>
            <div
              class="userInformation"
              @click.stop.prevent="goto('people', item.userId)"
            >
              <p class="title1" v-html="highlight(item.nickname)"></p>
              <p class="title2">
                <span v-if="item.area">
                  <span>
                    <img src="/static/v2/match/location_icon.png" alt />
                    {{ item.area }}
                  </span>
                  <span class="line">|</span>
                </span>
                <span class="works"
                  >{{ $t("global.作品") }} {{ item.videoCount || 0 }}</span
                >
                <span>{{ $t("global.粉丝") }} {{ item.fansCount || 0 }}</span>
              </p>
              <p
                class="title3"
                v-html="
                  language === 'zh'
                    ? highlight(delStyleTag(item.introduce))
                    : highlight(delStyleTag(item.enIntroduce))
                "
              ></p>
              <p
                class="follow"
                @click.stop.prevent="Follow(item)"
                v-if="!item.isFollow"
              >
                + {{ $t("global.关注") }}
              </p>
              <p
                v-else
                class="following"
                @mouseenter="ishoveFolloe = true"
                @mouseout="ishoveFolloe = false"
                @click.stop.prevent="Follow(item)"
              >
                {{
                  !ishoveFolloe ? $t("global.已关注") : $t("global.取消关注")
                }}
              </p>
            </div>
            <div
              class="userImg"
              v-for="(data, i) in item.items"
              :key="i"
              @click.stop.prevent="goto('video', data.videoId)"
            >
              <img :src="data.thumb | imageUrl('', 320, 180)" alt />
              <p class="title4">{{ data.title }}</p>
            </div>
          </li>
        </ul>
        <div v-if="isShowNone&&!lists.length" class="noDataImg">
          <div class="noDataBox">
            <img src="/static/newSearch/member_empty@2x.png" alt />
            <p>{{ $t("search.没有匹配的用户") }}</p>
          </div>
        </div>
      </div>
      <div class="searchRecruit clearfix" v-if="type == 6">
        <div class="searchLeft">
          <div v-if="lists.length">
            <div class="jobList clearfix" v-for="(item,i) in lists" :key="i">
            <div class="leftBox" @click.stop.prevent="goto('recruit', item.id)">
              <p class="title1">{{item.positionName}}<span>{{item.updateTime | formatDate("YYYY-MM-DD")}}</span></p>
              <p class="title2"><i>{{item.negotiable==1?$t('recruit.面议'):item.salaryBegin+'K-'+item.salaryEnd+"K"}}</i> / {{item.cityName}} / {{getExperience(item.experience)}} / {{getEducation(item.education)}} / {{getRecruitNature(item.recruitNature)}}</p>
            </div>
            <div class="rightBox" @click.stop.prevent="goto('people', item.userId)">
              <span>{{item.nickName}}</span><img :src="item.avatar | imageUrl('/static/profile_img_default.png',120,120)" alt="">
            </div>
          </div>
          </div>
          <div v-if="isShowNone&&!lists.length" class="noDataImg">
            <div class="noDataBox">
              <img class="img" src="https://image.manamana.net/1652689253000_undefinedfrQwDwR" alt />
              <p>{{$t('global.暂无数据')}}</p>
            </div>
          </div>
        </div>
        <div class="searchRight">
          <div class="recruitList" v-if="newRecruitList.length">
            <div class="title clearfix">{{$t('recruit.最新职位')}}<span @click="goto('jobs')">{{$t('recruit.查看全部')}}</span></div>
            <div class="listBox">
              <div class="list" v-for="(item,i) in newRecruitList" :key="i" @click="goto('recruit', item.id)">
                <p class="name">{{item.positionName}}</p>
                <p class="money"><span>{{item.negotiable==1?$t('recruit.面议'):item.salaryBegin+'K-'+item.salaryEnd+"K"}}</span> / {{item.cityName}} / {{$t('recruit.经验')}}{{getExperience(item.experience)}} / {{getEducation(item.education)}} / {{getRecruitNature(item.recruitNature)}}</p>
              </div>
            </div>
          </div>
          <div class="operation" v-if="locationList.length">
            <img
              class="locationImg"
              @click="gotoLocation"
              :src="
                JSON.parse(locationList[0].image)[0].key
                  | imageUrl('', 570, 320)
              "
              alt=""
            />
            <div class="advertisement" v-if="locationList[0].type == '2'">
              {{ $t("video.广告") }}
            </div>
          </div>
          <div class="uploadApp">
            <img
              :src="
                language === 'zh'
                  ? '/static/video/Sidebar_app_promo_CN@2x.png'
                  : '/static/video/Sidebar_app_promo_EN@2x.png'
              "
              alt
            />
          </div>
        </div>
      </div>
      <pagination
        :totalRecord="totalRecord"
        :pageSize="options.pageSize"
        :pageIndex="options.pageIndex"
        @OnCurrentChanged="changePage"
      />
    </div>
    <footer-down class="searchFooter"></footer-down>
  </div>
</template>

<script>
import HeaderTop from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";
import Pagination from "@/components/v2/Pagination";
export default {
  name: "Search",
  metaInfo() {
    return {
      title: this.$t("global.搜索页") + " | MANA"
    };
  },
  components: {
    HeaderTop,
    FooterDown,
    Pagination
  },
  data() {
    return {
      hasNextPage: false,
      ishoveFolloe: false,
      content: this.$route.query.content,
      type: 1,
      classTags: {},
      classSubTag: {},
      industryTags: {},
      industrySubTag: {},
      applicationTags: {},
      applicationSubTag: {},
      hotTags: {},
      hotSubTag: {},
      classMore: false,
      industryMore: false,
      applicationMore: false,
      hotMore: false,
      classTogger: true,
      industryTogger: true,
      applicationTogger: true,
      hotTogger: true,
      openTages: true,
      classIndex: 0,
      classSubIndex: null,
      industryIndex: 0,
      industrySubIndex: null,
      applicationIndex: 0,
      applicationSubIndex: null,
      hotIndex: 0,
      hotSubIndex: null,
      rightScrollHeight: null,
      options: {
        pageIndex: 1,
        pageSize: 16,
        videoOrderBy: null,
        type: 1,
        keyword: null,
        searchTagForms: []
      },
      totalRecord: 0,
      lists: [],
      activityCount: 0,
      recruitCount: 0,
      articleCount: 0,
      topicCount: 0,
      userCount: 0,
      videoCount: 0,
      hotList: [],
      tagsData: [],
      searchTagForms: [],
      isShow: false,
      locationList: [],
      isShowNone: false,
      newRecruitList: []
    };
  },
  created() {
    // this.options.keyword = this.content;
    this.init();
  },
  mounted() {},
  methods: {
    getExperience(i) {
      if (i == 1) {
        return this.$t('recruit.不限');
      }
      if (i == 2) {
        return this.$t('recruit.1年以下');
      }
      if (i == 3) {
        return this.$t('recruit.1-3年');
      }
      if (i == 4) {
        return this.$t('recruit.3-5年');
      }
      if (i == 5) {
        return this.$t('recruit.5-10年');
      }
      if (i == 6) {
        return this.$t('recruit.10年以上');
      }
    },
    getEducation(i) {
      if (i == 1) {
        return this.$t('recruit.不限');
      }
      if (i == 2) {
        return this.$t('recruit.大专');
      }
      if (i == 3) {
        return this.$t('recruit.本科');
      }
      if (i == 4) {
        return this.$t('recruit.硕士');
      }
      if (i == 5) {
        return this.$t('recruit.博士');
      }
    },
    getRecruitNature(i) {
      if (i == 1) {
        return this.$t('recruit.全职');
      }
      if (i == 2) {
        return this.$t('recruit.实习生');
      }
      if (i == 3) {
        return this.$t('recruit.校招');
      }
      if (i == 4) {
        return this.$t('recruit.兼职');
      }
    },
    init() {
      // this.rightScrollHeight = null;
      this.getLocation();
      this.type = this.$route.query.type || 1;
      this.content = this.$route.query.content;
      this.options.keyword = this.$route.query.content;
      this.options.type = this.$route.query.type || 1;
      this.options.videoOrderBy = this.$route.query.videoOrderBy || null;
      switch (this.type) {
        case 1:
          this.buriedPoint(36, 0);
          break;
        case 2:
          this.buriedPoint(39, 0);
          break;
        case 3:
          this.buriedPoint(45, 0);
          break;
        case 4:
          this.buriedPoint(29, 0);
          break;
        case 5:
          this.buriedPoint(42, 0);
          break;
        default:
          this.buriedPoint(36, 0);
      }
      this.getTags();
      this.getHotList();
      this.getNewRecruit();
    },
    getNewRecruit() {
      this.$http.get("/api/recruit/info/new").then((res)=>{
        if (res.code == "OK") {
          this.newRecruitList = res.data.list;
        }
      })
    },
    getLocation() {
      this.$http.get("/api/operations/list/4").then(res => {
        if (res.code === "OK") {
          this.locationList = res.data;
          this.locationShow(this.locationList[0]);
        }
      });
    },
    locationClick(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id
      };
      this.$http.post("/api/operations/click", params).then(res => {
        //运营位点击
      });
    },
    locationShow(item) {
      if (item.isFunc) {
        return;
      }
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id
      };
      this.$http.post("/api/operations/show", params).then(res => {
        //运营位展示
        item.isFunc = true;
      });
    },
    gotoLocation() {
      this.locationClick(this.locationList[0]);
      this.openLocatione(this.locationList[0]);
    },
    getCount(params) {
      this.$http
        .post("/api/search/count", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          let data = res.data;
          this.activityCount = data.activityCount || 0;
          this.articleCount = data.articleCount || 0;
          this.topicCount = data.topicCount || 0;
          this.userCount = data.userCount || 0;
          this.videoCount = data.videoCount || 0;
          this.recruitCount = data.recruitCount || 0;
        });
    },
    getHotList() {
      const url = `/api/stat/getRankingList`;
      const params = {
        type: 1,
        pageIndex: 1,
        pageSize: 10
      };
      this.$http.get(url, { params }).then(res => {
        this.hotList = res.data.list;
      });
    },
    subKeyArr(value) {
      var str = value;
      var newStr = "";
      var keys = [this.options.keyword];
      var keysArr = []; //字符串中截取的关键字数组
      var indexObj = {};
      if (str == null) {
        return value;
      }
      if (str.length == 0 || this.options.keyword == "") {
        return value;
      }
      if (str.indexOf(this.options.keyword) == -1) {
        return value;
      }
      if (str.length < 78) {
        return value;
      }
      for (var i = 0; i < str.length; i++) {
        var indexArr = []; //关键字索引数组 -- 关键字所在字符串的索引
        //    遍历关键字数组，分别获取他们在字符串中的位置（也就是索引）
        for (var j = 0; j < keys.length; j++) {
          var index = str.indexOf(keys[j]);
          if (index != -1) {
            indexArr.push(index); //不等于 -1 即存在该关键字，保存到关键字索引数组中
          }
        }
        //    如果关键字索引数组有值，则说明字符串中还存在关键字内容
        if (indexArr.length > 0) {
          indexObj = getMin(indexArr); //调用获取最小值函数
          var minEle = indexObj.minEle; //最小值（对应的是字符串的索引）
          var minIndex = indexObj.minIndex; //最小值对应的索引（对应的是关键字数组的索引）
          keysArr.push(
            str.substring(minEle - 30, minEle + keys[minIndex].length + 100)
          ); //截取所在索引的前两位，及后两位
          str = str.slice(minEle + keys[minIndex].length);
          i--;
        }
      }
      newStr = "..." + keysArr[0] + "...";
      return newStr;
      /**
       * 获取数组中的最小值和对应的索引
       * @param {Object} arr
       */
      function getMin(arr) {
        var minEle = Math.max.apply(Math, arr); //默认给该数组的最大值
        var minIndex = 0;
        for (var i = 0; i < arr.length; i++) {
          //如果当前元素的值比前面保存的值小，就替换，否则不改变
          if (arr[i] < minEle) {
            minEle = arr[i];
            minIndex = i;
          }
        }
        return {
          minEle: minEle,
          minIndex: minIndex
        };
      }
    },
    highlight: function(value) {
      let term = this.options.keyword;
      if (term == "") {
        return value;
      }
      if (value) {
        return value.replace(
          new RegExp(
            "(?![^&;]+;)(?!<[^<>]*)(" +
              term.replace(/([\^\$\(\)\[\]\{\}\*\.\+\?\|\\])/gi, "\\$1") +
              ")(?![^<>]*>)(?![^&;]+;)",
            "gi"
          ),
          "<i style='color:#3664ED'>$1</i>"
        );
      }
    },
    Follow(item) {
      var $this = this;
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      if (item.isFollow) {
        this.$http
          .post("/api/u/relation/unfollow/" + item.userId)
          .then(function(response) {
            if (response) {
              $this.getList();
              $this.$message(response.message);
            }
          });
      } else {
        this.$http
          .post("/api/u/relation/follow/" + item.userId)
          .then(function(response) {
            if (response.code === "OK") {
              $this.getList();
              $this.$message.success(response.message);
            }
          });
      }
    },
    goto(type, id, item) {
      let routeData = null,
        url = "";
      if (type == "video") {
        url = "/video/detail?id=" + id;
      }
      if (type == "people") {
        url = "/peopleCenter/" + id + "/home";
      }
      if (type == "article") {
        url = "/article/detail/" + id;
      }
      if (type == "subject") {
        url = "/subjectDetail/" + id + "/home";
      }
      if (type == "activity" && item.type == 2) {
        url = "/activityDetail/" + id;
      }
      if (type == "activity" && item.type == 1) {
        url = "/live/liveDetail?id=" + id;
      }
      if (type == "recruit") {
        url = "/recruitDetail/" + id
      }
      if (type == "jobs") {
        url = "/jobs/home"
      }
      routeData = this.$router.resolve({ path: url });
      window.open(routeData.href, "_blank");
    },
    image(item) {
      let src = "";
      if (item) {
        const imageList = item.match(/<img[^>]*>/);
        if (imageList && imageList.length) {
          imageList[0].replace(/ src="([^"]*)"/, (a, b) => (src = b));
        }
        return src;
      }
    },
    delStyleTag(str) {
      if (str) {
        return str
          .replace(/<style((?!<\/style>).)*<\/style>/g, "")
          .replace(/<style((?!<\/style>).)*<\/style>/g, "")
          .replace(/<[^>]+>/g, "");
      }
    },
    getList() {
      let params = {};
      if (this.type == 1) {
        params = {
          type: this.options.type,
          pageIndex: this.options.pageIndex,
          pageSize: this.options.pageSize,
          keyword: this.options.keyword,
          videoOrderBy: this.options.videoOrderBy,
          searchTagForms: this.searchTagForms.length
            ? this.searchTagForms
            : this.options.searchTagForms
        };
      } else {
        params = {
          type: this.options.type,
          pageIndex: this.options.pageIndex,
          pageSize: this.options.pageSize,
          keyword: this.options.keyword
        };
      }
      this.getCount(params);
      this.$http
        .post("/api/search/list2", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          this.lists = res.data.pageList.list;
          this.totalRecord = res.data.pageList.totalRecord;
          this.hasNextPage = res.data.pageList.hasNextPage;
          this.isShowNone = true;
        });
    },
    getTags() {
      this.$http.get("/api/video/tag/group/childnew").then(res => {
        let data = res.data;
        this.tagsData = res.data;
        for (let i = 0; i < data.length; i++) {
          if (data[i].id == 1) {
            this.classTags = data[i];
          }
          if (data[i].id == 11) {
            this.industryTags = data[i];
          }
          if (data[i].id == 14) {
            this.applicationTags = data[i];
          }
          if (data[i].id == 15) {
            this.hotTags = data[i];
          }
        }
        this.classTags.tagEditFroms.unshift({
          id: 0,
          name: "全部",
          enName: "All"
        });
        this.industryTags.tagEditFroms.unshift({
          id: 0,
          name: "全部",
          enName: "All"
        });
        this.applicationTags.tagEditFroms.unshift({
          id: 0,
          name: "全部",
          enName: "All"
        });
        this.hotTags.tagEditFroms.unshift({
          id: 0,
          name: "全部",
          enName: "All"
        });

        this.$nextTick(() => {
          // if (this.$refs.classTagHeight.offsetHeight > 64) {
          //   this.classMore = true;
          // }

          if (this.$refs.industryTagHeight1.offsetHeight > 36) {
            this.industryMore = true;
          }
          if (this.$refs.applicationTagHeight.offsetHeight > 36) {
            this.applicationMore = true;
          }
          if (this.$refs.hotTagHeight.offsetHeight > 36) {
            this.hotMore = true;
          }
          setTimeout(() => {
            this.rightScrollHeight =
              this.$refs.classTagHeight.offsetHeight +
              this.$refs.industryTagHeight.offsetHeight;
          }, 50);
        });
        if (
          this.$route.query.searchTagForms &&
          this.$route.query.searchTagForms.length
        ) {
          this.searchTagForms = JSON.parse(this.$route.query.searchTagForms);
        } else {
          this.options.searchTagForms = [];
        }
        this.getList();
      });
    },
    changeType(type) {
      this.type = type;
      // this.options.pageIndex = 1;
      // this.options.type = type;
      this.lists = [];
      this.isShowNone = false;
      this.totalRecord = 0;
      // this.totalRecord = 0;
      // this.getList();
      this.$router.push({
        path: "/Search",
        query: {
          content: this.content,
          type: type,
          searchTagForms: JSON.stringify(this.options.searchTagForms)
        }
      });
    },
    videoOrderBy(index) {
      // this.options.pageIndex = 1;
      // this.options.videoOrderBy = index;
      // this.getList();
      this.$router.push({
        path: "/Search",
        query: {
          content: this.content,
          type: this.options.type,
          videoOrderBy: index,
          searchTagForms: this.options.searchTagForms
        }
      });
    },
    changePage(pageIndex) {
      this.options.pageIndex = pageIndex;
      this.getList();
      // this.$router.push({
      //   path: "/Search",
      //   query: {
      //     content: this.content,
      //     type: this.options.type,
      //     pageIndex: pageIndex,
      //     videoOrderBy: this.options.videoOrderBy,
      //     searchTagForms: JSON.stringify(this.options.searchTagForms),
      //   },
      // });
    },
    searchSubmit() {
      if (!this.content.replace(/[\r\n\s]/g, "")) {
        this.$message.info(this.$t("global.请输入搜索内容"));
        return;
      }
      // this.options.pageIndex = 1;
      // this.options.keyword = this.content;
      // this.getList();
      // this.$router.push("/Search/" + this.content);
      if (this.type) {
        this.$router.push({ path: "/Search", query: { content: this.content,type: this.type } });
      } else {
        this.$router.push({ path: "/Search", query: { content: this.content } });
      }
      location.reload();
    },
    stopOpen() {
      this.openTages = !this.openTages;
      if (this.openTages) {
        this.classTogger = true;
        this.industryTogger = true;
        this.applicationTogger = true;
        this.hotTogger = true;
        this.$nextTick(() => {
          this.rightScrollHeight =
            this.$refs.classTagHeight.offsetHeight +
            this.$refs.industryTagHeight.offsetHeight;
        });
      }
    },
    classOpen(index) {
      if (index == 1) {
        this.classTogger = false;
      }
      if (index == 2) {
        this.classTogger = true;
      }
      if (index == 3) {
        this.industryTogger = false;
      }
      if (index == 4) {
        this.industryTogger = true;
      }
      if (this.openTages) {
        this.$nextTick(() => {
          this.rightScrollHeight =
            this.$refs.classTagHeight.offsetHeight +
            this.$refs.industryTagHeight.offsetHeight;
        });
      }
    },
    selectTags(id, item, type, y) {
      let topGroupId = null;
      let deteleTag = false;
      if (type == 1) {
        topGroupId = 1;
        this.classSubIndex = y;
      }
      if (type == 2) {
        topGroupId = 11;
        this.industrySubIndex = y;
      }
      if (type == 3) {
        topGroupId = 14;
        this.applicationSubIndex = y;
      }
      if (type == 4) {
        topGroupId = 15;
        this.hotSubIndex = y;
      }
      if (this.options.searchTagForms.length != 0) {
        for (let i = 0; i < this.options.searchTagForms.length; i++) {
          if (
            (this.options.searchTagForms[i].topGroupId == topGroupId &&
              this.options.searchTagForms[i].groupId == id &&
              this.options.searchTagForms[i].tagId == item.id) ||
            (this.options.searchTagForms[i].topGroupId == topGroupId && id == 0)
          ) {
            this.options.searchTagForms.splice(i, 1);
            if (type == 1) {
              this.classSubIndex = null;
              this.classIndex = 0;
              // if (id == 0) {
              //   this.classIndex = 0;
              // }
            }
            if (type == 2) {
              this.industrySubIndex = null;
              this.industryIndex = 0;
              // if (id == 0) {
              //   this.industryIndex = 0;
              // }
            }
            if (type == 3) {
              this.applicationSubIndex = null;
              this.applicationIndex = 0;
              // if (id == 0) {
              //   this.applicationIndex = 0;
              // }
            }
            if (type == 4) {
              this.hotSubIndex = null;
              this.hotIndex = 0;
              // if (id == 0) {
              //   this.hotIndex = 0;
              // }
            }
            // this.options.pageIndex = 1;
            // this.options.videoOrderBy = null;
            // this.getList();
            this.$router.push({
              path: "/Search",
              query: {
                content: this.content,
                type: 1,
                videoOrderBy: this.options.videoOrderBy,
                searchTagForms: JSON.stringify(this.options.searchTagForms)
              }
            });
            return;
          }
          if (this.options.searchTagForms[i].topGroupId == topGroupId) {
            this.options.searchTagForms.splice(i, 1);
            break;
          }
        }
      }
      this.options.searchTagForms.push({
        topGroupId: topGroupId,
        groupId: id,
        tagId: item.id
      });
      // this.options.pageIndex = 1;
      // this.options.videoOrderBy = null;
      // this.getList();
      this.$router.push({
        path: "/Search",
        query: {
          content: this.content,
          type: 1,
          videoOrderBy: this.options.videoOrderBy,
          searchTagForms: JSON.stringify(this.options.searchTagForms)
        }
      });
    },
    classSubTags(item, index, i) {
      if (item.id == 0) {
        if (index == 1) {
          this.classSubTag = {};
          this.classIndex = i;
          this.classSubIndex = null;
        }
        if (index == 2) {
          this.industrySubTag = {};
          this.industryIndex = i;
          this.industrySubIndex = null;
        }
        if (index == 3) {
          this.applicationSubTag = {};
          this.applicationIndex = i;
          this.applicationSubIndex = null;
        }
        if (index == 4) {
          this.hotSubTag = {};
          this.hotIndex = i;
          this.hotSubIndex = null;
        }

        this.selectTags(item.id, item, index, 0);
        // if (this.openTages) {
        //   this.$nextTick(() => {
        //     this.rightScrollHeight =
        //       this.$refs.classTagHeight.offsetHeight +
        //       this.$refs.industryTagHeight.offsetHeight;
        //   });
        // }
        return;
      }
      if (item.isGroup == false) {
        if (index == 1) {
          this.classSubTag = {};
          this.classIndex = i;
          this.classSubIndex = null;
        }
        if (index == 2) {
          this.industrySubTag = {};
          this.industryIndex = i;
          this.industrySubIndex = null;
        }
        if (index == 3) {
          this.applicationSubTag = {};
          this.applicationIndex = i;
          this.applicationSubIndex = null;
        }
        if (index == 4) {
          this.hotSubTag = {};
          this.hotIndex = i;
          this.hotSubIndex = null;
        }
        this.selectTags(item.tagId, { id: item.tagId }, index, 0);
        return;
      }
      this.$http
        .get("/api/video/tag/category/child/" + item.tagId)
        .then(res => {
          if (index == 1) {
            this.classSubTag = {};
            this.classIndex = i;
            this.classSubIndex = null;
            let data = [];
            data = res.data;
            data.unshift({
              id: 0,
              name: "全部",
              enName: "All"
            });
            this.classSubTag = {
              id: item.id,
              data: data
            };
          }
          if (index == 2) {
            this.industrySubTag = {};
            this.industryIndex = i;
            this.industrySubIndex = null;
            let data = [];
            data = res.data;
            data.unshift({
              id: 0,
              name: "全部",
              enName: "All"
            });
            this.industrySubTag = {
              id: item.id,
              data: data
            };
          }
          if (index == 3) {
            this.applicationSubTag = {};
            this.applicationIndex = i;
            this.applicationSubIndex = null;
            let data = [];
            data = res.data;
            data.unshift({
              id: 0,
              name: "全部",
              enName: "All"
            });
            this.applicationSubTag = {
              id: item.id,
              data: data
            };
          }
          if (index == 4) {
            this.hotSubTag = {};
            this.hotIndex = i;
            this.hotSubIndex = null;
            let data = [];
            data = res.data;
            data.unshift({
              id: 0,
              name: "全部",
              enName: "All"
            });
            this.hotSubTag = {
              id: item.id,
              data: data
            };
          }
          // if (this.openTages) {
          //   this.$nextTick(() => {
          //     this.rightScrollHeight =
          //       this.$refs.classTagHeight.offsetHeight +
          //       this.$refs.industryTagHeight.offsetHeight;
          //   });
          // }
          this.selectTags(item.id, { id: 0 }, index, 0);
        });
    }
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  watch: {
    $route(to, from) {
      // window.location.reload();
      // this.content = this.$route.params.content;
      // this.options.keyword = this.content;
      // this.options1.keyword = this.content;
      this.init();
      this.searchTagForms = [];
    }
  }
};
</script>

<style lang="stylus" scoped>
.search {
  background: #fff;
  width: 100%;
  padding-bottom: 70px;
  min-height: 80vh;

  .searchTop {
    width: 1110px;
    margin: 0 auto;
    padding-top: 40px;

    .topNav {
      border-bottom: 1px solid #E0E0E0;
      height: 50px;

      .nav {
        float: left;
        margin-top: 8px;

        li {
          float: left;
          margin-right: 50px;
          color: #666;

          span {
            font-size: 18px;
            font-weight: 400;
            margin-right: 4px;
            position: relative;

            &:hover {
              color: #2026CC;
              cursor: pointer;
            }

            .line {
              position: absolute;
              width: 100%;
              height: 3px;
              background: #0A0A0A;
              left: 0;
              bottom: -19px;
            }
          }

          span.active {
            font-weight: 600;
            color: rgba(10, 10, 10, 1);
          }

          i {
            font-size: 14px;
            font-weight: 400;
            color: #999;
          }
        }
      }

      .searchInput {
        float: right;
        width: 214px;
        height: 42px;
        background: rgba(245, 245, 245, 1);
        position: relative;

        img {
          width: 18px;
          height: 18px;
          position: absolute;
          right: 20px;
          top: 12px;
          cursor: pointer;
        }

        input {
          width: 160px;
          height: 42px;
          line-height: 42px;
          background: rgba(245, 245, 245, 1);
          padding: 0 0 0 10px;
          font-size: 16px;
          font-weight: 400;
          color: #666666;
        }
      }
    }

    .tagsBox {
      position: relative;

      .tags {
        background: rgba(245, 245, 245, 1);
        margin: 30px auto 60px;
        width: 1070px;
        padding: 10px 20px;
        font-size: 13px;

        .group {
          border-bottom: 1px solid #E0E0E0;
          position: relative;

          &:nth-child(4) {
            border-bottom: none;
          }

          .name {
            width: 70px;
            float: left;
            padding-top: 15px;
            color: #999;
            font-weight: 500;
          }

          .open {
            position: absolute;
            right: 0;
            top: 12px;
            cursor: pointer;

            span {
              font-size: 13px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);

              img {
                width: 20px;
                height: 20px;
                vertical-align: bottom;
              }

              &:hover {
                color: #333;
              }
            }
          }

          .groupTag {
            width: 945px;
            float: left;
            padding-bottom: 10px;

            .groupTagLi {
              float: left;
              margin-right: 36px;
              color: #333;
              font-weight: 400;
              height: 24px;
              line-height: 24px;
              margin-top: 10px;
              cursor: pointer;
              font-size: 13px;

              &:hover {
                color: #2026CC;
              }
            }

            .active {
              background: rgba(32, 38, 204, 1);
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
              padding: 0 10px;
              margin-right: 24px;

              &:hover {
                color: rgba(255, 255, 255, 1);
              }
            }
          }

          .subTag {
            width: 952px;
            padding: 2px 24px 12px;
            float: left;
            margin-left: 70px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 10px;

            .subTagLi {
              float: left;
              margin-right: 36px;
              color: rgba(102, 102, 102, 1);
              font-weight: 400;
              height: 20px;
              line-height: 20px;
              margin-top: 10px;
              cursor: pointer;
            }

            .active {
              color: #2026CC;
              font-weight: 600;
            }
          }

          .hideMore {
            height: 36px;
            overflow: hidden;
          }
        }

        .hideBottom {
          border-bottom: none;
        }
      }

      .hideTags {
        overflow: hidden;
      }

      .openTages {
        position: absolute;
        width: 44px;
        height: 20px;
        background: rgba(245, 245, 245, 1);
        left: 50%;
        transform: translateX(-50%);
        bottom: -20px;
        text-align: center;
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .searchVideo {
    width: 1110px;
    margin: 0 auto;

    .searchLeft {
      width: 730px;
      float: left;

      .searchResult {
        .left {
          float: left;
          font-size: 16px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);

          i {
            color: #2026CC;
          }
        }

        .right {
          float: right;
          font-size: 13px;
          font-weight: 500;
          color: #999;
          line-height: 20px;
          cursor: pointer;

          &:hover {
            color: #333;
          }

          img {
            width: 20px;
            height: 20px;
            vertical-align: bottom;
          }
        }
      }

      .sort {
        margin: 30px 0;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);

        span {
          margin-right: 30px;
          cursor: pointer;

          &:hover {
            color: #2026CC;
          }
        }

        span.active {
          font-weight: 600;
          color: rgba(10, 10, 10, 1);
        }
      }

      .list {
        .list_li {
          cursor: pointer;

          .li_video {
            margin-bottom: 40px;

            .left {
              float: left;
              margin-right: 15px;
              position: relative;
              height: 112px;

              img {
                width: 200px;
                height: 112px;
              }

              span {
                position: absolute;
                right: 5px;
                bottom: 5px;
                min-width: 43px;
                height: 20px;
                background: rgba(10, 10, 10, 0.8);
                font-size: 12px;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
                line-height: 20px;
                text-align: center;
              }
            }

            .right {
              float: left;
              width: 515px;
              position: relative;

              .title1 {
                width: 100%;
                font-size: 16px;
                font-weight: 600;
                color: rgba(10, 10, 10, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-clamp: 2;
              }

              .title2 {
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-clamp: 2;
                margin: 10px 0;
              }

              .title3 {
                margin-bottom: 10px;

                .name {
                  font-size: 12px;
                  font-weight: 600;
                  color: #666;
                  margin-right: 20px;
                  display: inline-block;
                  max-width: 360px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  vertical-align: bottom;

                  &:hover {
                    color: #333;
                  }
                }

                .time {
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(153, 153, 153, 1);
                  margin-right: 20px;
                }

                .countNumber {
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(184, 184, 184, 1);
                  height: 16px;
                  line-height: 16px;

                  img {
                    width: 18px;
                    height: 12px;
                    margin-right: 4px;
                    margin-bottom: 3px;
                  }
                }
              }

              .title4 {
                width: 460px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                span {
                  display: inline-block;
                  padding: 0 5px;
                  height: 22px;
                  line-height: 22px;
                  text-align: center;
                  background: #f5f5f5;
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(153, 153, 153, 1);
                  margin-right: 8px;
                }
              }

              .title5 {
                position: absolute;
                right: 0;
                bottom: 0;
                font-size: 12px;
                font-weight: 400;
                color: rgba(184, 184, 184, 1);
                height: 16px;
                line-height: 16px;

                img {
                  width: 18px;
                  height: 12px;
                  margin-right: 4px;
                }
              }
            }
          }

          .li_article {
            margin-bottom: 40px;

            .left {
              float: left;
              margin-right: 15px;
              position: relative;
              width: 200px;
              height: 112px;
              background: #F5F5F5;
              text-align: center;

              img {
                width: 200px;
                height: 112px;
              }

              img.deflautImg {
                width: 64px;
                height: 64px;
                margin-top: 24px;
              }

              span {
                position: absolute;
                right: 0;
                bottom: 0;
                min-width: 60px;
                height: 26px;
                background: linear-gradient(135deg, rgba(54, 100, 237, 1) 0%, rgba(32, 38, 204, 1) 100%);
                font-size: 14px;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
                text-align: center;
                line-height: 26px;
              }
            }

            .right {
              float: left;
              width: 515px;

              .title1 {
                width: 100%;
                font-size: 16px;
                font-weight: 600;
                color: rgba(10, 10, 10, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-clamp: 2;
              }

              .title2 {
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-clamp: 2;
                margin: 10px 0;
              }

              .title3 {
                margin-bottom: 10px;

                .name {
                  font-size: 12px;
                  font-weight: 600;
                  color: #666;
                  margin-right: 20px;
                }

                .time {
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(153, 153, 153, 1);
                }
              }

              .title4 {
                span {
                  display: inline-block;
                  padding: 0 5px;
                  height: 22px;
                  line-height: 22px;
                  text-align: center;
                  background: rgba(235, 235, 235, 1);
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(153, 153, 153, 1);
                }
              }
            }
          }

          .li_channel {
            margin-bottom: 40px;
            position: relative;

            .left {
              float: left;
              margin-right: 15px;
              position: relative;
              height: 200px;

              img {
                width: 200px;
                height: 200px;
              }

              span {
                position: absolute;
                right: 0;
                bottom: 0;
                min-width: 60px;
                height: 26px;
                background: linear-gradient(135deg, rgba(54, 100, 237, 1) 0%, rgba(32, 38, 204, 1) 100%);
                font-size: 14px;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
                text-align: center;
                line-height: 26px;
              }
            }

            .right {
              float: left;
              width: 515px;

              .title1 {
                width: 100%;
                font-size: 16px;
                font-weight: 600;
                color: rgba(10, 10, 10, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-clamp: 2;
              }

              .title2 {
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                line-clamp: 3;
                margin: 10px 0;
              }

              .title3 {
                position: absolute;
                bottom: 0;
                font-size: 13px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);

                span {
                  margin-right: 20px;

                  i {
                    margin-left: 5px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .searchRight {
      width: 285px;
      float: right;

      .hot {
        .hot_title {
          font-size: 20px;
          font-weight: 600;
          color: rgba(10, 10, 10, 1);
          margin-bottom: 20px;
        }

        .topThree {
          margin-bottom: 12px;
          cursor: pointer;

          .number {
            float: left;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: linear-gradient(135deg, rgba(255, 160, 139, 1) 0%, rgba(254, 86, 48, 1) 100%);
            font-size: 12px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
          }

          .topImg {
            float: left;
            width: 95px;
            height: 54px;
            margin: 0 10px;
          }

          .information {
            float: left;
            width: 150px;

            .title {
              min-height: 21px;
              font-size: 14px;
              font-weight: 400;
              color: #333;
              line-height: 21px;
              margin-bottom: 6px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              &:hover {
                color: rgba(10, 10, 10, 1);
              }
            }

            .name {
              font-size: 12px;
              font-weight: 400;
              color: #999;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              &:hover {
                color: rgba(51, 51, 51, 1);
              }
            }
          }
        }

        .topEnd {
          margin-bottom: 12px;
          cursor: pointer;

          .number {
            float: left;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: linear-gradient(135deg, rgba(215, 217, 230, 1) 0%, rgba(135, 139, 160, 1) 100%);
            font-size: 12px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
          }

          .information {
            float: left;
            width: 255px;
            margin-left: 10px;
            font-size: 14px;
            font-weight: 400;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .title {
              color: #333;

              &:hover {
                color: rgba(10, 10, 10, 1);
              }
            }

            .name {
              color: #999;
            }
          }
        }
      }

      .operation {
        margin-top: 70px;
        width: 285px;
        height: 160px;
        position: relative;
        .locationImg {
          width: 100%;
          height: 100%;
          display: inline-block;
          cursor: pointer;
        }

        .advertisement {
          position: absolute;
          left: 0;
          bottom: 0;
          padding: 0 4px;
          height: 16px;
          background: rgba(51, 51, 51, 0.4);
          border-radius: 0px 6px 0px 0px;
          line-height: 16px;
          text-align: center;
          font-size: 10px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
        }
      }

      .uploadApp {
        width: 285px;
        height: 340px;
        margin-top: 70px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .searchChannel {
    width: 1110px;
    margin: 0 auto;
    padding-top: 30px;

    .channelUl {
      .channelLi {
        float: left;
        margin-right: 64px;
        margin-bottom: 40px;
        position: relative;
        cursor: pointer;

        &:nth-child(2n) {
          margin-right: 0;
        }

        .left {
          float: left;
          width: 125px;
          height: 125px;
          margin-right: 15px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .right {
          float: left;
          width: 383px;

          .title1 {
            font-size: 18px;
            font-weight: 600;
            color: #0A0A0A;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-clamp: 2;
            margin-bottom: 10px;
          }

          .title2 {
            font-size: 13px;
            font-weight: 400;
            color: #999;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-clamp: 2;
          }

          .title3 {
            position: absolute;
            bottom: 0;
            font-size: 13px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            span {
              margin-right: 20px;

              i {
                margin-left: 5px;
              }
            }
          }
        }
      }
    }
  }

  .searchVideoArticle {
    width: 1110px;
    margin: 0 auto;
    padding-top: 30px;

    .articleList {
      width: 730px;
      height: 138px;
      border-bottom: 1px solid #EBEBEB;
      margin-bottom: 24px;
      cursor: pointer;

      .left {
        float: left;
        margin-right: 12px;
        width: 545px;

        .title1 {
          font-size: 16px;
          font-weight: 600;
          color: #0A0A0A;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .title2 {
          font-size: 14px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin: 12px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-clamp: 2;
        }

        .information {
          .name {
            float: left;
            font-size: 12px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;

            img {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              margin-right: 5px;
            }
          }

          .time {
            float: left;
            margin: 0 20px 0 30px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(184, 184, 184, 1);
            line-height: 30px;
          }

          .amount {
            float: left;
            font-size: 12px;
            font-weight: 400;
            color: rgba(184, 184, 184, 1);
            line-height: 30px;

            img {
              width: 14px;
              height: 10px;
              vertical-align: middle;
              margin-right: 3px;
            }
          }
        }
      }

      .noImg {
        width: 635px;
      }

      .right {
        float: left;
        width: 173px;
        height: 100px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .searchActivity {
    width: 1110px;
    margin: 0 auto;
    padding-top: 30px;

    .activityUl {
      .activityLi {
        display: inline-block;
        margin-right: 30px;
        margin-bottom: 40px;
        width: 255px;
        cursor: pointer;

        &:nth-child(4n) {
          margin-right: 0;
        }

        .activityImg {
          width: 255px;
          height: 339px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .title1 {
            position: absolute;
            width: 48px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            background: rgba(0, 0, 0, 0.8);
            border-radius: 2px;
            right: 10px;
            bottom: 10px;
            font-size: 14px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
          }

          .title2 {
            position: absolute;
            width: 88px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: rgba(255, 255, 255, 1);
            left: 0;
            bottom: -15px;
            font-size: 14px;
            font-weight: 500;
          }

          .liveing {
            border: 1px solid rgba(254, 86, 48, 1);
            color: #FE5630;
          }

          .begining {
            border: 1px solid rgba(32, 38, 204, 1);
            color: #2026CC;
          }

          .Finished {
            border: 1px solid rgba(102, 102, 102, 1);
            color: #666666;
          }

          .haveing {
            border: 1px solid rgba(32, 38, 204, 1);
            color: #2026CC;
          }

          &:hover .liveing {
            background: #FE5630;
            color: #fff;
          }

          &:hover .begining {
            background: #2026CC;
            color: #fff;
          }

          &:hover .Finished {
            background: #666666;
            color: #fff;
          }

          &:hover .haveing {
            background: #FE5630;
            color: #fff;
          }
        }

        .title3 {
          width: 100%;
          margin: 30px 0 9px 0;
          font-size: 16px;
          height: 44px;
          line-height: 22px;
          font-weight: 600;
          color: #0A0A0A;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-clamp: 2;
        }

        .title4 {
          font-size: 14px;
          font-weight: 600;
          color: rgba(153, 153, 153, 1);
        }
      }
    }
  }

  .searchUser {
    width: 1110px;
    margin: 0 auto;
    padding-top: 30px;

    .userUl {
      .userLi {
        border-bottom: 1px solid #EBEBEB;
        padding: 30px 0 20px 0;
        width: 100%;

        .avactImg {
          float: left;
          width: 95px;
          height: 95px;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .userInformation {
          float: left;
          margin: 0 60px 0 20px;
          width: 425px;
          cursor: pointer;

          .title1 {
            font-size: 16px;
            font-weight: 600;
            color: #0A0A0A;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .title2 {
            font-size: 12px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            margin: 5px 0;

            img {
              width: 10px;
              height: 13px;
              margin-right: 4px;
            }

            span.line {
              color: #E0E0E0;
              margin: 0 15px;
            }

            span.works {
              margin-right: 10px;
            }
          }

          .title3 {
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            margin-bottom: 16px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .follow {
            display: inline-block;
            padding: 0 12px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border: 1px solid rgba(32, 38, 204, 1);
            font-size: 12px;
            font-weight: 600;
            color: rgba(32, 38, 204, 1);
            cursor: pointer;
          }

          .following {
            display: inline-block;
            padding: 0 12px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            border: 1px solid rgba(184, 184, 184, 1);
            font-size: 12px;
            font-weight: 600;
            color: rgba(184, 184, 184, 1);
            cursor: pointer;
          }
        }

        .userImg {
          float: left;
          width: 160px;
          margin-left: 15px;
          cursor: pointer;

          &:nth-child(3) {
            margin-left: 0;
          }

          img {
            width: 160px;
            height: 90px;
            margin-bottom: 5px;
          }

          .title4 {
            font-size: 12px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-clamp: 2;
          }
        }
      }
    }
  }
  .searchRecruit{
    width: 1110px;
    margin: 0 auto;
    .searchLeft{
      width: 730px;
      float: left;
      .jobList{
        height: 88px;
        border-bottom: 1px solid #EBEBEB;
        padding-top: 30px;
        cursor: pointer;
        .leftBox{
          width: 56%;
          float: left;
          .title1{
            height: 28px;
            font-size: 20px;
            font-weight: 600;
            color: #333333;
            line-height: 28px;
            max-width: 70%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 7px;
            span{
              margin-left: 10px;
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 17px;
            }
          }
          .title2{
            height: 25px;
            font-size: 14px;
            font-weight: 400;
            color: #333;
            line-height: 25px;
            i{
              color: #FC703E;
              font-size: 18px;
              font-weight: 600;
            }
          }
        }
        .rightBox{
          width: 44%;
          float: left;
          text-align: right;
          span{
            display: inline-block;
            max-width: 246px;
            margin-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 25px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            vertical-align: middle;
          }
          img{
            width: 60px;
            height: 60px;
            border-radius: 50%;
          }
        }
      }
    }
    .searchRight{
      width: 285px;
      float: right;
      padding-top: 30px;
      .recruitList{
        .title{
          height: 30px;
          font-size: 20px;
          font-weight: 600;
          color: #0A0A0A;
          line-height: 30px;
          span{
            float: right;
            height: 17px;
            font-size: 12px;
            font-weight: 500;
            color: #2026CC;
            cursor: pointer;
          }
        }
        .listBox{
          .list{
            margin-top: 20px;
            cursor: pointer;
            .name{
              height: 20px;
              font-size: 14px;
              font-weight: 600;
              color: #0A0A0A;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 5px;
            }
            .money{
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #999;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              span{
                color: #FF7E00;
                font-weight: 600;
              }
            }
          }
        }
      }
      .operation {
        margin-top: 70px;
        width: 285px;
        height: 160px;
        position: relative;
        .locationImg {
          width: 100%;
          height: 100%;
          display: inline-block;
          cursor: pointer;
        }

        .advertisement {
          position: absolute;
          left: 0;
          bottom: 0;
          padding: 0 4px;
          height: 16px;
          background: rgba(51, 51, 51, 0.4);
          border-radius: 0px 6px 0px 0px;
          line-height: 16px;
          text-align: center;
          font-size: 10px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
        }
      }

      .uploadApp {
        width: 285px;
        height: 340px;
        margin-top: 70px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.noDataImg {
  width: 100%;
  padding-top: 80px;

  .noDataBox {
    margin: 0 auto;
    text-align: center;
    img {
      width: 88px;
      height: 88px;
      margin: 0 56px;
      margin-bottom: 30px;
    }
    img.img{
      width: 284px;
      height: 276px;
      margin-bottom: 40px;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      color: #354052;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/search/newSearch.vue